import { TASK_ATTRIBUTE } from "../apiConstant";
import BaseApi from "../baseApi";

class TaskAttributeApi extends BaseApi {
  constructor() {
    super();
    this.BASE_URL = process.env.REACT_APP_PROJECT_MANAGEMENT_API_URL || "";
    this.$axiosInstance = this.initAxiosInstance();
  }

  updateTaskAttribute(request) {
    return this.post(`${TASK_ATTRIBUTE}/update`, request);
  }
}

export default TaskAttributeApi;
